import Pagination from 'rc-pagination';
import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { Col, Row } from 'reactstrap';
import E911List from '../../../components/e911List';
import { ENG_LOCALE } from '../../../lib/constants';

export default function E911(props) {
  const {
    numbers,
    renderList,
    sort,
    openModalReq,
    handleSortProvisioning,
    handleChangePagination,
  } = props;

  return (
    <>
      <Row>
        <Col md={12}>
          {numbers?.allNumbers?.docs && (
            <E911List
              e911={renderList}
              opneAddressModal={openModalReq}
              sortValue={sort}
              onSort={handleSortProvisioning}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          {numbers.allNumbers.totalPages > 1 && (
            <Pagination
              locale={ENG_LOCALE}
              className="pagination-container"
              onChange={handleChangePagination}
              current={numbers.allNumbers.page}
              total={numbers.allNumbers.totalDocs}
              pageSize={numbers.allNumbers.limit}
              showLessItems
              showTitle={false}
              showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
            />
          )}
        </Col>
      </Row>
    </>
  );
}
